const lazyLoad = (targetSl) => {
    const targets = document.querySelectorAll(targetSl);

    if (!targets.length) {
        return;
    }

    const options = {
        threshold: 0.2
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const dataSrcSet = entry.target.getAttribute('data-srcset'); 
                const dataSrc = entry.target.getAttribute('data-src'); 
                const dataStyle = entry.target.getAttribute('data-style'); 

                if (dataSrcSet) {
                    entry.target.setAttribute('srcset', dataSrcSet);
                    entry.target.removeAttribute('data-srcset');
                }

                if(dataSrc) {
                    entry.target.setAttribute('src', dataSrc);
                    entry.target.removeAttribute('data-src');
                }

                if (dataStyle) {
                    entry.target.setAttribute('style', dataStyle);
                    entry.target.removeAttribute('data-style');
                }
            }
        });
    }, options);

    [...targets].map((target) => observer.observe(target));
};

export default lazyLoad;

